module.exports = {
  title: '资源管理',
  route: {
    path: '/system-manage',
    children: {
      path: 'manage-resource',
    },
  },
};
